import { render, staticRenderFns } from "./AssignEarningDeductionGroup.vue?vue&type=template&id=9fa19ab2&scoped=true"
import script from "./AssignEarningDeductionGroup.vue?vue&type=script&lang=js"
export * from "./AssignEarningDeductionGroup.vue?vue&type=script&lang=js"
import style0 from "./AssignEarningDeductionGroup.vue?vue&type=style&index=0&id=9fa19ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa19ab2",
  null
  
)

export default component.exports